import http from '../http'

/**
 * 文件上传相关接口
 */
const uploadApi = {
  /**
   * 上传图片
   * @param {FormData} formData - 表单数据
   * @param {Function} onProgress - 上传进度回调
   * @returns {Promise}
   */
  image(formData, onProgress) {
    return http.upload('/file/upload', formData, onProgress)
  },

  /**
   * 上传文件
   * @param {FormData} formData - 表单数据
   * @param {Function} onProgress - 上传进度回调
   * @returns {Promise}
   */
  file(formData, onProgress) {
    return http.upload('/upload/file', formData, onProgress)
  },

  /**
   * 上传视频
   * @param {FormData} formData - 表单数据
   * @param {Function} onProgress - 上传进度回调
   * @returns {Promise}
   */
  video(formData, onProgress) {
    return http.upload('/upload/video', formData, onProgress)
  },
}

export default uploadApi 